import { getMasterConfigApiService, MASTER_CONFIG_ENDPOINTS } from './config';
import type {
  MasterCategory,
  MasterValue,
  CreateMasterCategoryPayload,
  CreateMasterValuePayload,
  UpdateMasterValuePayload,
} from './types';

export const masterConfigApi = {
  listCategories: () =>
    getMasterConfigApiService().get<MasterCategory[]>(MASTER_CONFIG_ENDPOINTS.categories),

  createCategory: (data: CreateMasterCategoryPayload) =>
    getMasterConfigApiService().post<MasterCategory>(
      MASTER_CONFIG_ENDPOINTS.categoriesAdmin,
      data,
    ),

  listValues: (categoryCode: string) =>
    getMasterConfigApiService().get<MasterValue[]>(
      `${MASTER_CONFIG_ENDPOINTS.categoryValues}/${categoryCode}/values`,
    ),

  createValue: (data: CreateMasterValuePayload) =>
    getMasterConfigApiService().post<MasterValue>(MASTER_CONFIG_ENDPOINTS.valuesAdmin, data),

  updateValue: (id: string, data: UpdateMasterValuePayload) =>
    getMasterConfigApiService().put<MasterValue>(
      `${MASTER_CONFIG_ENDPOINTS.valuesAdmin}/${id}`,
      data,
    ),

  deleteValue: (id: string) =>
    getMasterConfigApiService().delete<void>(`${MASTER_CONFIG_ENDPOINTS.valuesAdmin}/${id}`),

  reorderValues: (categoryCode: string, orderedIds: string[]) =>
    getMasterConfigApiService().put<void>(MASTER_CONFIG_ENDPOINTS.valuesReorder, {
      category_code: categoryCode,
      ordered_ids: orderedIds,
    }),

  seedDefaults: () => getMasterConfigApiService().post<void>(MASTER_CONFIG_ENDPOINTS.seed),

  getApprovalReasons: () =>
    getMasterConfigApiService().get<MasterValue[]>(MASTER_CONFIG_ENDPOINTS.approvalReasons),
};
